/**
 * Helper function that seperates values from our seo-optimized url structure.
 * This implementation is a bit hacky, because the songId contains dashes and the songname can in some cases also contain dashes, while the seperation of the params is also a dash.
 * This implementation works on the assumption that the songId always has a constant amount of dashes.
 * @param songParams URL path in the format of "songname-songId".
 */
export const getSongIdFromUrlSongParams = (songParams: string) => {
  /** Token to seperate the string by. */
  const delimiter = '-';

  /** Constant amount of dashes in song id's. */
  const AMOUNT_OF_DASHES_IN_SONGID = 4;

  const splittedParams = songParams.split(delimiter);

  /*
   * Slice from the back, so that we only slice the songId and not the songName (which could include dashes and would make this implementation fail).
   * Also add 1 to the AMOUNT_OF_DASHES to seperate at the seperating dash between songName and songId, counted from the back.
   */
  const sclicedParamStrings = splittedParams.slice(
    splittedParams.length - (AMOUNT_OF_DASHES_IN_SONGID + 1)
  );

  if (sclicedParamStrings.length !== 5)
    throw new Error('Song id could not be retrieved correctly from the url.');

  /* Rejoin the parameters with a dash to resemble the songId again. */
  const songId = sclicedParamStrings.join('-');

  return songId;
};

export const AI_GENERATED_SONG_PREFIX = 'aisong-';

export const isAIGeneratedSong = (songParams: string) =>
  songParams.startsWith(AI_GENERATED_SONG_PREFIX);
